var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2805_1322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0111 27.6978H43.5271C44.0774 27.6978 44.6119 27.8813 45.046 28.2193C45.4802 28.5573 45.7891 29.0305 45.9241 29.5639L48.8088 40.9696C48.901 41.3344 48.9088 41.7154 48.8315 42.0837C48.7542 42.452 48.5938 42.7977 48.3627 43.0947C48.1315 43.3916 47.8356 43.6318 47.4975 43.7971C47.1595 43.9623 46.7881 44.0482 46.4118 44.0482H3.66915C3.28754 44.0482 2.91112 43.9598 2.56935 43.7901C2.22758 43.6203 1.92974 43.3738 1.69916 43.0697C1.46858 42.7657 1.31151 42.4123 1.24026 42.0375C1.16901 41.6626 1.1855 41.2763 1.28845 40.9088L4.4838 29.5032C4.62932 28.9837 4.94075 28.5261 5.37059 28.2002C5.80042 27.8742 6.32507 27.6978 6.86453 27.6978H21.1241",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9983 18.6753C28.1421 18.6753 30.6906 16.1267 30.6906 12.9829C30.6906 9.83909 28.1421 7.29053 24.9983 7.29053C21.8545 7.29053 19.3059 9.83909 19.3059 12.9829C19.3059 16.1267 21.8545 18.6753 24.9983 18.6753Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8782 12.8315C35.8782 18.0858 27.5593 29.7298 25.4699 32.5715C25.4156 32.6455 25.3446 32.7057 25.2626 32.7472C25.1807 32.7887 25.0902 32.8103 24.9983 32.8103C24.9065 32.8103 24.8159 32.7887 24.734 32.7472C24.6521 32.7057 24.581 32.6455 24.5267 32.5715C22.4373 29.7299 14.1184 18.0858 14.1184 12.8315C14.1204 9.94727 15.2675 7.18181 17.3077 5.14303C19.3478 3.10424 22.1141 1.95898 24.9983 1.95898C27.8826 1.95898 30.6488 3.10424 32.689 5.14303C34.7291 7.18181 35.8763 9.94727 35.8782 12.8315Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.125 37.9227H37.6905V34.2512V27.6982",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0828 34.1455H37.6904",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4233 37.9224V44.0482",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2805_1322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons05);
export default __webpack_public_path__ + "static/media/icons-05.632e3362cb9a85956e19c479dd487db6.svg";
export { ForwardRef as ReactComponent };